import { render, staticRenderFns } from "./RareIndustryOverview3YOYTable.vue?vue&type=template&id=68bd7a62&scoped=true"
import script from "./RareIndustryOverview3YOYTable.vue?vue&type=script&lang=js"
export * from "./RareIndustryOverview3YOYTable.vue?vue&type=script&lang=js"
import style0 from "./RareIndustryOverview3YOYTable.vue?vue&type=style&index=0&id=68bd7a62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bd7a62",
  null
  
)

export default component.exports